import { ProviderWebsiteModel } from '@admin/shared/models/provider-website-model';
import { Serializable } from '@admin/core/models/serializable';

export class AnnouncementDistributionChannel
  implements Serializable<AnnouncementDistributionChannel>
{
  fromObject(obj: any): AnnouncementDistributionChannel {
    Object.assign(this, obj);

    if (obj.providerWebsite != null) {
      let t = new ProviderWebsiteModel();
      t = t.fromObject(obj.providerWebsite);
      this.providerWebsite = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public announcementDistributionChannelId: number;
  public announcementId: number;
  public priorityExpireDate: Date;
  public providerWebsite: ProviderWebsiteModel;
}
